import axios from 'axios'

const DEFAULT_TITLE = process.env.VUE_APP_TITLE || '应用系统'
const CACHE_KEY = 'bymy.siteConfig'

let loadPromise = null

function readCache() {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function writeCache(data) {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify(data))
  } catch {
    // ignore quota errors
  }
}

export function getDefaultPageTitle() {
  return DEFAULT_TITLE
}

export function resolvePageTitle(config) {
  const pageTitle = (config?.pageTitle || '').trim()
  if (pageTitle) return pageTitle
  const siteName = (config?.siteName || '').trim()
  if (siteName) return siteName
  return DEFAULT_TITLE
}

export function applyPageTitle(title) {
  const value = (title || '').trim()
  if (value) document.title = value
}

export function applyCachedPageTitle() {
  const cached = readCache()
  if (cached) applyPageTitle(resolvePageTitle(cached))
}

export function invalidateSiteConfigCache() {
  sessionStorage.removeItem(CACHE_KEY)
}

export async function loadSiteConfig(force = false) {
  if (!force) {
    const cached = readCache()
    if (cached) {
      applyPageTitle(resolvePageTitle(cached))
      return cached
    }
    if (loadPromise) return loadPromise
  }

  loadPromise = (async () => {
    try {
      const res = await axios.get('/api/configs/public/site')
      const data = res?.data?.data || {}
      writeCache(data)
      applyPageTitle(resolvePageTitle(data))
      return data
    } catch {
      const fallback = readCache() || { pageTitle: '', siteName: '' }
      applyPageTitle(resolvePageTitle(fallback))
      return fallback
    } finally {
      loadPromise = null
    }
  })()

  return loadPromise
}

export async function refreshSiteConfig() {
  invalidateSiteConfigCache()
  const data = await loadSiteConfig(true)
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('bymy:site-config-updated', { detail: data }))
  }
  return data
}

export function pickConfigValue(list, key) {
  const target = (list || []).find((item) => (item.configKey || item.key || item.name) === key)
  return target?.configValue || target?.value || target?.config_value || target?.val || ''
}
